import { render } from "./SurveyPage09.vue?vue&type=template&id=4c8a0826&scoped=true"
const script = {}

import "./SurveyPage09.vue?vue&type=style&index=0&id=4c8a0826&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8a0826"]])

export default __exports__